export const CART_ADD_ITEM = 'CART_ADD_ITEM'
export const CART_CLEAR_ITEMS = 'CART_RESET'
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM'
export const CART_SAVE_SHIPPING_INFO = 'CART_SAVE_SHIPPING_INFO'

export const GET_OTP_TO_ORDER_REQUEST = 'GET_OTP_TO_ORDER_REQUEST'
export const GET_OTP_TO_ORDER_SUCCESS = 'GET_OTP_TO_ORDER_SUCCESS'
export const GET_OTP_TO_ORDER_FAIL = 'GET_OTP_TO_ORDER_FAIL'